/* eslint-disable react/jsx-key */
// Station
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo, getEnvConfig, getPermitActions } from 'core'
import { connect } from 'react-redux'
import {
  getApsPiEntity,
  updateApsPiEntity,
  deleteApsPiEntity,
} from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { Input, Button } from 'antd'
import { Label } from 'core/screen-util'

const headers = [
  strCol({
    ident: 'piTag',
    display: 'PI Tag',
    isKey: true,
    width: 300,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'piType',
    display: 'PI Type',
    isFiltered: true,
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'idName',
    display: 'ID Name',
    isFiltered: true,
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'idValue',
    display: 'ID Value',
    isFiltered: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'stationId',
    display: 'Station ID',
    isFiltered: true,
    width: 200,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'PI Entity'

const Station = _ => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 200px 100px 200px 100px 200px 200px',
          gap: 10,
        }}
      >
        <Label>PI Tag :</Label>
        <Input
          value={insertData.piTag}
          onChange={e =>
            setInsertData({ ...insertData, piTag: e.target.value })
          }
        />
        <Label>PI Type :</Label>
        <Input
          value={insertData.piType}
          onChange={e =>
            setInsertData({ ...insertData, piType: e.target.value })
          }
        />
        <Label>Station ID :</Label>
        <Input
          value={insertData.stationId}
          onChange={e =>
            setInsertData({ ...insertData, stationId: e.target.value })
          }
        />
        <div />
        <Label>ID Name :</Label>
        <Input
          value={insertData.idName}
          onChange={e =>
            setInsertData({ ...insertData, idName: e.target.value })
          }
        />
        <Label>ID Value :</Label>
        <Input
          value={insertData.idValue}
          onChange={e =>
            setInsertData({ ...insertData, idValue: e.target.value })
          }
        />

        <div />
        <div
          style={{
            gridColumnEnd: 'span 2',
            gap: 10,
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={updateApsPiEntity}
      retrieveTask={getApsPiEntity}
      deleteTask={deleteApsPiEntity}
      altBy={d => d.piTag + d.piType}
      autoRetrieve
      sortOptions={headers}
      initialSortOptions={headers}
      widthOffset={50}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(Station)
